import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as MoreFiltersEmptyIcon } from "./assets/more-filters-empty.svg";

type Props = {
  onSelectCategory: () => void;
  selectedCategoryCount?: number;
};

const MoreFiltersPlaceholder: FC<Props> = ({
  onSelectCategory,
  selectedCategoryCount = 0
}) => {
  const { t } = useTranslation("productListing");
  const hasMultiple = selectedCategoryCount > 1;

  return (
    <div className="more_filters_placeholder">
      <div className="more_filters_icon">
        <MoreFiltersEmptyIcon />
      </div>
      <h4 className="more_filters_title">
        {hasMultiple
          ? t("multipleCategoriesSelected", { count: selectedCategoryCount })
          : t("selectOneCategory")}
      </h4>
      <p className="more_filters_desc">
        {hasMultiple ? t("multipleCategoriesDesc") : t("selectOneCategoryDesc")}
      </p>
      <button className="more_filters_select_btn" onClick={onSelectCategory}>
        {t("selectCategoryBtn")}
      </button>
    </div>
  );
};

export default MoreFiltersPlaceholder;
